import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

/**
 * Loading placeholder for the Accounts inventory table.
 * Bones approximate the header + four account rows. See `docs/loading-skeletons.md`.
 */
@Component({
  selector: 'bn-accounts-skeleton',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Skeleton],
  template: `
    <div
      class="bn-accounts-skeleton"
      data-testid="accounts-skeleton"
      role="status"
      aria-label="Loading accounts"
    >
      <div class="bn-accounts-skeleton__header">
        <p-skeleton width="5.5rem" height="0.75rem" />
        <p-skeleton width="6rem" height="0.75rem" />
        <p-skeleton width="3.5rem" height="0.75rem" />
        <p-skeleton width="3.5rem" height="0.75rem" />
        <p-skeleton width="4.5rem" height="0.75rem" styleClass="bn-accounts-skeleton__end" />
        <p-skeleton width="5.5rem" height="0.75rem" styleClass="bn-accounts-skeleton__end" />
      </div>
      @for (row of rows; track row) {
        <div class="bn-accounts-skeleton__row">
          <div class="bn-accounts-skeleton__name">
            <p-skeleton [width]="row.name" height="0.75rem" />
            <p-skeleton width="2.25rem" height="0.55rem" />
          </div>
          <p-skeleton [width]="row.institution" height="0.75rem" />
          <p-skeleton [width]="row.type" height="0.75rem" />
          <p-skeleton width="3.5rem" height="1.25rem" borderRadius="999px" />
          <p-skeleton [width]="row.balance" height="0.75rem" styleClass="bn-accounts-skeleton__end" />
          <p-skeleton width="4.75rem" height="0.75rem" styleClass="bn-accounts-skeleton__end" />
        </div>
      }
    </div>
  `,
  styleUrl: './accounts-skeleton.component.scss',
})
export class AccountsSkeletonComponent {
  readonly rows = [
    { name: '70%', institution: '55%', type: '45%', balance: '4.5rem' },
    { name: '62%', institution: '55%', type: '50%', balance: '3.5rem' },
    { name: '58%', institution: '55%', type: '72%', balance: '3.25rem' },
    { name: '48%', institution: '50%', type: '32%', balance: '5rem' },
  ];
}
